module.exports = __webpack_public_path__ + "img/75.status_garbage_can.b7838f7f.svg";